module.exports = __webpack_public_path__ + "img/firstview-sp-2748906bce0886c004e9b190eb989531.feaedadf.jpg";